import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Form, EmployeeField } from '@ali/deep';
import '@ali/deep/lib/employee-search/style.js';

class EmployeeSelector extends Component {
  constructor(props) {
    super(props);
    
    // 初始化状态，处理传入的初始值
    let initialValue = props.value || [];

    // 如果initialValue是对象数组，直接使用
    if (Array.isArray(initialValue) && initialValue.length > 0 && typeof initialValue[0] === 'object') {
      // 确保对象有必要的字段
      initialValue = initialValue.map(item => ({
        ...item,
        value: item.value || item.workNo || '',
        label: item.label || item.displayName || item.name || item.nickName || '',
        workNo: item.workNo || item.value || ''
      }));
    }
    // 如果initialValue是字符串数组，转换为对象数组
    else if (Array.isArray(initialValue) && initialValue.length > 0 && typeof initialValue[0] === 'string') {
      initialValue = initialValue.map(workNo => ({
        value: workNo,
        label: workNo,
        workNo: workNo
      }));
    }

    this.state = {
      selectedEmployees: Array.isArray(initialValue) ? initialValue : []
    };

    // 创建ref以获取EmployeeField实例
    this.employeeFieldRef = React.createRef();

    this.handleChange = this.handleChange.bind(this);
    this.saveRef = this.saveRef.bind(this);
  }

  // 保存ref
  saveRef(ref) {
    // 保存EmployeeField实例的引用
    this.employeeFieldRef.current = ref && ref.getInstance ? ref.getInstance() : ref;
  }

  // 处理值变化
  handleChange(valueObj) {
    // 从valueObj中提取value，如果valueObj本身就是数组则直接使用
    let value = valueObj;
    if (valueObj && typeof valueObj === 'object' && 'value' in valueObj) {
      value = valueObj.value;
    }

    // 如果value仍然是undefined或null，尝试从ref中获取值
    if ((!value || value.length === 0) && this.employeeFieldRef && this.employeeFieldRef.current) {
      try {
        const refValue = this.employeeFieldRef.current.getValue();
        if (refValue && refValue.length > 0) {
          value = refValue;
        }
      } catch (e) {
        // 如果无法从ref获取值，则使用原始value
        console.log(`EmployeeSelector[${this.props.name}] failed to get value from ref:`, e);
      }
    }

    const employees = Array.isArray(value) ? value : [];
    this.setState({ selectedEmployees: employees });

    // 打印日志
    console.log(`EmployeeSelector[${this.props.name}] value changed:`, employees);
    console.log(`EmployeeSelector[${this.props.name}] raw valueObj:`, valueObj);
    console.log(`EmployeeSelector[${this.props.name}] final value:`, value);

    // 调用父组件传递的onChange方法
    if (this.props.onChange) {
      this.props.onChange(employees);
    }
  }

  // 处理组件接收新props的情况
  componentDidUpdate(prevProps) {
    // 当表单重置时，清空已选员工
    if (this.props.value !== prevProps.value && !this.props.value) {
      this.setState({
        selectedEmployees: []
      });
    } else if (this.props.value !== prevProps.value) {
      // 处理传入的值，确保它是正确的格式
      let newValue = this.props.value || [];

      // 如果newValue是对象数组，直接使用
      if (Array.isArray(newValue) && newValue.length > 0 && typeof newValue[0] === 'object') {
        // 确保对象有必要的字段
        newValue = newValue.map(item => ({
          ...item,
          value: item.value || item.workNo || '',
          label: item.label || item.displayName || item.name || item.nickName || '',
          workNo: item.workNo || item.value || ''
        }));
      }
      // 如果newValue是字符串数组，转换为对象数组
      else if (Array.isArray(newValue) && newValue.length > 0 && typeof newValue[0] === 'string') {
        newValue = newValue.map(workNo => ({
          value: workNo,
          label: workNo,
          workNo: workNo
        }));
      }

      this.setState({
        selectedEmployees: Array.isArray(newValue) ? newValue : []
      });
    }
  }

  render() {
    const { label, name, required, multiple = true, className } = this.props;
    const { selectedEmployees } = this.state;

    return (
      <Form.Item
        label={label}
        name={name}
        required={required}
        getValueFromEvent={this.handleChange}
        getValueProps={() => ({ value: selectedEmployees })}
      >
        <EmployeeField
          ref={this.saveRef}
          name={name}
          labelAlign="top"
          url="/api/user/searchEmpInfo"
          multiple={multiple}
          fetchDataOnMount={false}
          required={required}
          showSearch
          hasArrow
          hiddenSelected={true}
          value={selectedEmployees}
          onChange={this.handleChange}
        />
      </Form.Item>
    );
  }
}

// 定义 PropTypes
EmployeeSelector.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  required: PropTypes.bool,
  multiple: PropTypes.bool,
  className: PropTypes.string,
  value: PropTypes.array,
  onChange: PropTypes.func,
};

// 定义默认 props
EmployeeSelector.defaultProps = {
  multiple: true,
  required: false,
  value: [],
};

export default EmployeeSelector;